export default "__VITE_ASSET__e13b2851__"